/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyDomain = void 0;
var PrivacyDomain;
(function (PrivacyDomain) {
    PrivacyDomain["Public"] = "public";
    PrivacyDomain["Private"] = "private";
})(PrivacyDomain || (exports.PrivacyDomain = PrivacyDomain = {}));
